import { config } from '@iheartjane/config';

import type { Identification } from '@jane/shared/types';

import { request } from '../lib/request';

export class IdentificationSource {
  static urlRoot = `${config.apiPath}/documents`;

  static get() {
    return request(this.urlRoot, {
      method: 'GET',
    });
  }

  static update(documentPart: { document: Partial<Identification> }) {
    return request(this.urlRoot, {
      method: 'PATCH',
      body: JSON.stringify(documentPart),
    });
  }
}
